// /admin/groups: every family group, largest or newest first.
import { useNavigate } from 'react-router-dom'

import { getGroups } from '../../../api/adminV2'
import { Chips, ListSearch, Pager, PAGE_SIZE, useListParams } from '../list'
import { formatDate, formatNumber, LoadError, Loading, useLoad } from '../ui'

const SORTS = [
  ['largest', 'Largest first'],
  ['newest', 'Newest first'],
]

const Groups = () => {
  const navigate = useNavigate()
  const { read, page, update, key } = useListParams({ sort: 'largest' })
  const sort = read('sort')
  const q = read('q')

  const { data, error, loading, reload } = useLoad(
    () => getGroups({ sort, q: q || undefined, page, size: PAGE_SIZE }),
    [key]
  )
  const rows = data?.data || []
  const total = Number(data?.total) || 0

  return (
    <>
      <div className="a-head">
        <div>
          <h1>Family groups</h1>
          <p className="a-sub">
            {data
              ? `${formatNumber(total)} ${total === 1 ? 'group' : 'groups'}${
                  q ? ` matching "${q}"` : ''
                } · ${sort === 'newest' ? 'newest' : 'largest'} first`
              : 'Every family group in Morsel.'}
          </p>
        </div>
      </div>
      <section className="a-panel">
        <div className="a-toolbar">
          <Chips
            options={SORTS}
            value={sort}
            label="Order"
            onChange={(value) => update({ sort: value })}
          />
          <ListSearch
            value={q}
            placeholder="Search by group name"
            onChange={(value) => update({ q: value }, { replace: !!q })}
          />
          {loading && data ? <span className="a-muted a-small-text">Loading…</span> : null}
        </div>
        {error ? (
          <LoadError error={error} onRetry={reload} />
        ) : !data ? (
          <Loading />
        ) : (
          <>
            <div className="a-table-wrap">
              <table className="a-table">
                <thead>
                  <tr>
                    <th>Group</th>
                    <th>Owner</th>
                    <th className="a-num-cell">Members</th>
                    <th className="a-num-cell">Recipes</th>
                    <th>Started</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.length ? (
                    rows.map((g) => (
                      <tr
                        className="a-click"
                        key={g.id}
                        onClick={() => navigate(`/admin/groups/${g.id}`)}
                      >
                        <td>
                          <b>{g.name}</b>
                        </td>
                        <td className="a-who">
                          <b>{g.owner_name || <span className="a-muted">No owner</span>}</b>
                          {g.owner_email ? <span>{g.owner_email}</span> : null}
                        </td>
                        <td className="a-num-cell">{Number(g.member_count) || 0}</td>
                        <td className="a-num-cell">{Number(g.recipe_count) || 0}</td>
                        <td className="a-nowrap">{formatDate(g.created_at)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="a-muted">
                        {q ? `No groups match "${q}".` : 'No family groups yet.'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <Pager
              data={data}
              page={page}
              note={sort === 'newest' ? 'newest first' : 'largest first'}
              onPage={(p) => update({ page: p })}
            />
          </>
        )}
      </section>
    </>
  )
}

export default Groups
